<section class="page">
  <header class="page-header">
    <h2>Commandes passées de séquençage</h2>
    <p class="subtitle">Collez des noms de cartouches séparés par espaces ou retours à la ligne.</p>
  </header>

  <section class="panel">
    <label class="field">
      <span>Noms de cartouches</span>
      <textarea
        [(ngModel)]="cartouchesInput"
        rows="10"
        placeholder="Exemple:
P1098-ASV-I01 P1098-ASV-I02
P1098-ASV-I03"
      ></textarea>
    </label>

    <label class="checkbox-field">
      <input type="checkbox" [ngModel]="commande" (ngModelChange)="onCommandeChange($event)" />
      <span>Commandé</span>
    </label>

    <label class="field">
      <span>Date de commande</span>
      <input type="date" [(ngModel)]="dateCommande" [disabled]="!commande" />
    </label>

    <button type="button" (click)="save()" [disabled]="saving">
      {{ saving ? 'Enregistrement...' : 'Enregistrer' }}
    </button>

    @if (success) {
      <p class="success">{{ success }}</p>
    }

    @if (error) {
      <p class="error">{{ error }}</p>
    }
  </section>
</section>
